export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM6.51 18.488A8.5 8.5 0 0 0 18.489 6.51L6.511 18.489ZM12 3.5a8.5 8.5 0 0 0-6.545 13.923L17.423 5.455A8.465 8.465 0 0 0 12 3.5Z"/>
</svg>
`;
